import React from 'react';
import FrontPage from './Components/FrontPage/FrontPage';
function Content () {
    return (
       <FrontPage />
    );
};

export default Content;